export default __webpack_public_path__ + "983cb52.png";